import { VerificationStatus } from 'src/common/models/verificationModels';
import { FC, useEffect, useReducer } from 'react';
import {
  verificationStatusActionMap,
  VerificationStatusActionType,
  verificationStatusReducer,
} from 'src/pages/VerificationPage/reducers/verificationStatusReducer';
import {
  Content,
  ContentWrapper,
  Heading,
  ImageDesktop,
  ProcessStateWrapper,
  SectionWrapper,
  SubsectionTitle,
  VerificationCard,
} from './VerificationPageSuccessPageFlow.styled';
import Logo from '@tenant/components/Logo';
import { VerificationPageDescription } from 'src/pages/VerificationPage/components/VerificationPageDescription';
import { VerificationPageActions } from 'src/pages/VerificationPage/components/VerificationPageActions';
import { VerificationPageProcessingStep } from 'src/pages/VerificationPage/components/VerificationPageProcessingStep';
import { DoneCoverImage } from 'src/common/images/DoneCoverImage';
import Footer from '@tenant/components/Footer';
import { LayoutContainer } from 'src/common/components/Layout/LayoutContainer';
import { RetryVerificationProcessModal } from 'src/pages/VerificationPage/components/RetryVerificationProcessModal';
import { isNil } from 'ramda';

export type VerificationPageSuccessPageFlowProps = {
  verificationStatus?: VerificationStatus;
};

export const VerificationPageSuccessPageFlow: FC<
  VerificationPageSuccessPageFlowProps
> = ({ verificationStatus }) => {
  const [verificationStatusState, dispatchVerificationStatus] = useReducer(
    verificationStatusReducer,
    {
      isDownloading: true,
    }
  );

  useEffect(() => {
    if (isNil(verificationStatus)) {
      return;
    }

    const verificationStatusAction =
      verificationStatusActionMap.get(verificationStatus);

    !isNil(verificationStatusAction) &&
      dispatchVerificationStatus(verificationStatusAction);

  }, [verificationStatus]);

  return (
    <LayoutContainer>
      <RetryVerificationProcessModal
        verificationStatus={verificationStatus}
        onClose={() =>
          dispatchVerificationStatus({
            type: VerificationStatusActionType.Done,
          })
        }
      />

      <ContentWrapper>
        <Content>
          <Logo />
          <Heading>Weryfikacja</Heading>

          <VerificationPageDescription
            verificationState={verificationStatusState}
          />

          <SectionWrapper>
            {verificationStatus === VerificationStatus.Expired ? (
              <VerificationPageActions status={verificationStatus} />
            ) : (
              <>
                <SubsectionTitle>Weryfikacja</SubsectionTitle>
                <VerificationCard>
                  <ProcessStateWrapper>
                    <VerificationPageProcessingStep
                      text="Pobieranie danych"
                      isError={verificationStatusState.isError}
                      isLoading={verificationStatusState.isDownloading}
                      isSuccess={!verificationStatusState.isDownloading}
                    />
                    <VerificationPageProcessingStep
                      text="Analiza danych"
                      isError={verificationStatusState.isError}
                      isLoading={verificationStatusState.isAnalyzing}
                      isSuccess={verificationStatusState.isSuccess}
                    />
                    <VerificationPageProcessingStep
                      text="Operacja zakończona"
                      isError={verificationStatusState.isError}
                      isSuccess={verificationStatusState.isSuccess}
                    />
                  </ProcessStateWrapper>

                  <VerificationPageActions status={verificationStatus} />
                </VerificationCard>
              </>
            )}
          </SectionWrapper>
        </Content>
        <ImageDesktop>
          <DoneCoverImage />
        </ImageDesktop>
      </ContentWrapper>
      <Footer />
    </LayoutContainer>
  );
};
